<template id="predicoes-baixas-edit">
  <v-container
    id="wizard"
    tag="section"
    ref="predicoesedit"
  >
    <v-row justify="center">
      <v-dialog
        v-model="dialogPrecisao"
        max-width="900"
      >
        <v-card>
          <v-card-title class="headline">
            Diferenças de Precisão:
          </v-card-title>
          <v-card-text 
            v-for="option in cardOptions"
            :key="option.text"
          >
            <span class="font-weight-bold">{{option.text}}: </span><span>{{option.description}}</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="dialogPrecisao = false"
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <predicoes-material-wizard
      id="predicao-baixas-card-principal"
      v-model="tab"
      :available-steps="availableSteps"
      :items="tabs"
      class="mx-auto"
      @click:next="next()"
      @click:prev="tab--"
      :loading="loading"
      :disabledBtnFinalizar="validTabs[tab+1] === false"
    >
      <div id="predicao-baixas-infos-basicas">
        <v-tab-item class="pb-12">
          <validation-observer v-slot="{ valid }">
            <validation-helper :interceptor="valid" @isValid="validTabs[1] = $event" />

            <form>
              <div class="text-center display-1 font-weight-normal mb-6">
                Vamos começar preenchendo as informações básicas
              </div>

              <v-row
                id="predicao-baixas-info-nome"
                class="mx-auto"
              >
                <v-col cols=12>
                  <validation-provider v-slot="{ errors }" rules="required">
                    <v-text-field
                      label="Nome do Predição"
                      outlined
                      :error-messages="errors"
                      v-model="titulo"
                    />
                  </validation-provider>
                </v-col>
              </v-row>

              <v-row
                id="predicao-baixas-info-base"
                class="mx-auto"
              >
                <v-col cols=12>
                  <v-select
                    v-model="base"
                    name="base"
                    label="Base"
                    :items="baseOptions"
                    item-value="base"
                    item-text="nome"
                    outlined
                    class="mb-0 pb-0"
                  />
                </v-col>
              </v-row>

              <v-row
                id="predicao-baixas-info-variaveis"
                class="mx-auto"
              >
                <v-col cols=12>
                  <validation-provider v-slot="{ errors }" rules="required">
                    <v-select
                      :error-messages="errors"
                      v-model="variaveis"
                      name="var"
                      label="Variáveis"
                      :items="variaveisList"
                      outlined
                      chips
                      small-chips
                      multiple
                      class="mb-0 pb-0"
                    />
                  </validation-provider>
                </v-col>
              </v-row>

              <v-row
                id="predicao-baixas-info-database"
                class="mx-auto"
              >
                <v-col cols=12>
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="100"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-if="base === 'ais'" v-slot:activator="{ on, attrs }">
                      <validation-provider v-slot="{ errors }" rules="required|min:7">
                        <v-text-field
                          v-model="monthFormattedAis"
                          :error-messages="errors"
                          type="tel" v-mask="'##/####'"
                          label="Data Base AIS"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          @blur="monthAis = parseMonth(monthFormattedAis);"
                        />
                      </validation-provider>
                    </template>
                    <template v-else-if="base === 'laudo'" v-slot:activator="{ on, attrs }">
                      <validation-provider v-slot="{ errors }" rules="required|min:7">
                        <v-text-field
                          v-model="monthFormattedLaudo"
                          :error-messages="errors"
                          type="tel" v-mask="'##/####'"
                          label="Data Base Laudo"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          @blur="monthLaudo = parseMonth(monthFormattedLaudo);"
                        />
                      </validation-provider>
                    </template>
                    <v-date-picker
                      v-if="base === 'ais'"
                      type="month" 
                      v-model="monthAis"
                      @input="menu = false; monthFormattedAis = formatMonth(monthAis);"
                      :landscape="false"
                      locale="pt-br"
                    />
                    <v-date-picker
                      v-else-if="base === 'laudo'"
                      type="month" 
                      v-model="monthLaudo"
                      @input="menu = false; monthFormattedLaudo = formatMonth(monthLaudo);"
                      :landscape="false"
                      locale="pt-br"
                    />
                  </v-menu>
                </v-col>
              </v-row>
            </form>
          </validation-observer>
        </v-tab-item>
      </div>

      <div id="predicao-baixas-precisao">
        <v-tab-item class="pb-12">
          <form>
            <v-responsive class="mx-auto">
              <div class="text-center display-1 font-weight-normal mb-6">
                Qual a precisão desejada? 
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="mb-1"
                      id="btn-info-precisoes"
                      medium
                      @click="dialogPrecisao = true"
                    >
                      mdi-progress-question
                    </v-icon>
                  </template>
                  <span>Clique aqui para obter um informativo sobre as diferenças das precisões</span>
                </v-tooltip>
              </div>  
              <div id="predicao-baixas-select-precisao">
                <general-card-item-group
                  :optionalId="true"
                  mandatory
                  ref="precisao" 
                  :options="cardOptions" 
                  defaultOption="rapido"
                  v-model="precisao"
                />
              </div>
            </v-responsive>
          </form>
        </v-tab-item>
      </div>

      <div id="predicao-baixas-tucagens">
        <v-tab-item class="pb-12">
          <div class="text-center display-1 font-weight-normal mb-6">
            Para finalizar, preencha as informações sobre as tucagens
          </div>
          <div class="body-2 error--text text-center">
            Inserir apenas Quantidades inteiras
          </div>

          <form>
            <div style="max-height: 300px; overflow-y: scroll;">
              <v-row class="mx-auto" justify="space-around">
                <v-col
                  id="predicao-baixas-tucagens-table"
                  cols="auto"
                  class="text-center"
                >
                  <general-spread-sheet ref="tucagens" :rows.sync="rows" :columns.sync="columns" />
                </v-col>
              </v-row>
            </div>
            <validation-provider rules="required" tag="div" v-slot="{ invalid }">
              <input type="hidden" name="valida-tucagens" :value="validTucagens">
              <div v-if="invalid"  class="v-messages theme--light error--text text-center">
                Insira pelo menos uma tucagem.
              </div>
            </validation-provider>
          </form>
        </v-tab-item>
      </div>
    </predicoes-material-wizard>
  </v-container>
</template>

<script>
  import TabelasService from '@/services/TabelasService';
  import PredicoesService from '@/services/PredicoesBaixasService.js';
  import tourMixins from '@/mixins/tourMixins';
  import dayjs from 'dayjs';

  export default {
    name: 'EditPredicaoBaixa',

    mixins: [tourMixins],

    components: { 
      ValidationHelper: () => import("@/components/general/ValidationHelper.vue"),
      GeneralSpreadSheet: () => import('@/components/general/GeneralSpreadSheet'),
      GeneralCardItemGroup: () => import('@/components/general/GeneralCardItemGroup'),
      PredicoesMaterialWizard: () => import('@/components/predicoesBaixas/PredicoesMaterialWizard'),
    },
    
    mounted () {
      this.getUltimaDataBase();
    },
    
    data: () => ({
        tab: 0,
        tabs: ['Início', 'Precisão', 'Tucagens'],
        validTabs: {0: true, 1: false, 2: true, 3: true}, /* 0: Início; 1: Precisão; 2: Tucagens; 3: Finalizar */
        availableSteps: [0],
        predicao: {},
        titulo: '',
        variaveis: ['VOC'],
        columns: [
          { type: "text", title: "Tucagem", width: "190px" },
          { type: "numeric", title: "Qtd Min", width: "100px" },
          { type: "numeric", title: "Qtd Max", width: "100px" }
        ],
        rows: [ ["255.02","50","70"], ["295.01", "240787","294296"] ], 
        cardOptions: [
            { value: "rapido", text: "Rápido", description:"Gera rapidamente um conjunto de cenários com o tamanho e precisão razoáveis, para uma análise macro.", icon:"mdi-clock-fast"},
            { value: "moderado", text: "Moderado", description:"Gera em um tempo moderado um conjunto de cenários com o tamanho e precisão razoáveis, para uma análise estatística mais apurada.", icon:"mdi-play-circle-outline"},
            { value: "preciso", text: "Preciso", description:"Gera em um tempo longo um conjunto de cenários com o tamanho e precisão máxima, para uma análise estatística completa.", icon:"mdi-target"},
        ],
        base: 'ais',
        baseOptions:[
          {base:'ais', nome:'AIS'},
          {base:'laudo', nome:'Laudo'},
        ],
        precisao: "rapido",
        dialogPrecisao: false,
        monthAis: null,
        monthFormattedAis: null,
        monthLaudo: null,
        monthFormattedLaudo: null,
        menu: false,
        loading: false,
        arrPrimeiraTabTour: [
          {
            element: "#predicao-baixas-infos-basicas",
            title: "Aba Início",
            intro: "Aqui você poderá escolher um nome para seu sua predição de baixas, selecionar a base de dados e a data base.",
            scrollTo: "tooltip",
            position: 'left'
          },
        ],
        arrSegundaTabTour: [
          {
            element: "#predicao-baixas-precisao",
            title: "Aba Precisão",
            intro: `Aqui você poderá escolher a precisão de sua predição de baixas.<br><br>
            Obs: Escolha de acordo com a demanda de sua análise.`,
            scrollTo: "tooltip",
            position: "left"
          }, 
          {
            element: "#btn-info-precisoes",
            intro: "Sempre que precisar você poderá clicar sobre este icone e ter informações sobre a diferença de cada uma das precisões.",
            scrollTo: "tooltip",
            position: "bottom"
          },
          {
            element: "#general-card-item-rapido",
            intro: "Gera rapidamente um conjunto de cenários com o tamanho e precisão razoáveis, para uma análise macro.",
            scrollTo: "tooltip",
            position: "top"
          },
          {
            element: "#general-card-item-moderado",
            intro: "Gera em um tempo moderado um conjunto de cenários com o tamanho e precisão razoáveis, para uma análise estatística mais apurada.",
            scrollTo: "tooltip",
            position: "top"
          },
          {
            element: "#general-card-item-preciso",
            intro: "Gera em um tempo longo um conjunto de cenários com o tamanho e precisão máxima, para uma análise estatística completa.",
            scrollTo: "tooltip",
            position: "top"
          },
        ],
        arrTerceiraTabTour: [
          {
            element: "#predicao-baixas-tucagens",
            title: "Aba Tucagens",
            intro: `Nesta etapa você poderá escolher os bens que farão parte da análise utilizando suas respectivas tucagens e quantidade desejada.<br><br>
            Dica: Caso não tenha certeza de um ou mais atributos deixar vazio.
            `,
            scrollTo: "tooltip",
            position: "left"
          },
          {
            element: "#predicao-baixas-tucagens-table",
            intro: `Obs¹: Esse é um exemplo de configuração de tucagens.<br><br>
            Obs²: Essa tabela poderá ser utlizada com atalhos semelhantes ao excel, (enter, setas ← ↑↓→)
            `,
            scrollTo: "tooltip",
            position: "left"
          },
          {
            element: "#predicao-baixas-variacao-qtd",
            intro: "Por último temos a variação sobre as quantidades baixadas (%). Para mais ou para menos.",
            scrollTo: "tooltip",
            position: "top"
          },
        ],
    }),


    computed: {
      stepsProps() {
        return `${this.validTabs[0]}|${this.validTabs[1]}|${this.validTabs[2]}`;
      },
      validTucagens() {
        if (this.rows.length == 0) return undefined;
        
        let invalidos = this.rows.filter(row => (!row[0].trim() || !row[1].trim() || !row[2].trim()));

        return (invalidos.length > 0) ? undefined : "OK"; 
      },
      variaveisList() {
        const lista = {
          ais: ['VOC','VOC Residual', 'VNR', 'VNR Residual'],
          laudo: ['VOC','VOC Residual', 'VNR', 'VNR Residual']
        };

        return lista[this.base];
      }
    },

    methods: {
      iniciarPrimeiraTabTour() {

        this.doneLabel = 'Proximo';
        this.desativarTourAoSair = false;

        let onBeforeExitFunction = {
          func: (() => {
            this.tab = 1;
            this.iniciarSegundaTabTour();
          })
        };
        this.iniciarTour(this.arrPrimeiraTabTour, [], [], [onBeforeExitFunction]);

      },

      iniciarSegundaTabTour() {

        this.doneLabel = 'Proximo';
        this.desativarTourAoSair = false;

        let onBeforeExitFunction = {
          func: (() => {
            this.tab = 2;
            this.iniciarTerceiraTabTour();
          })
        };

        this.iniciarTour(this.arrSegundaTabTour, [], [], [onBeforeExitFunction]);
      },

      iniciarTerceiraTabTour() {
        this.doneLabel = 'Finalizar';
        this.desativarTourAoSair = true;

        let onBeforeExitFunction = {
          func: (() => this.tab = 0)
        };

        this.iniciarTour(this.arrTerceiraTabTour, [], [], [onBeforeExitFunction]);
      },

      next () {
        if (this.tab === this.tabs.length - 1) {
          this.postPredicao()
        } else {
          this.tab++
        }
      },

      getUltimaDataBase () {
        TabelasService.getTabelaResumo()
        .then(response => {
          const dataAis = response.data.tabela_resumo.data_base_ais;
          this.monthAis = dataAis ? dataAis : '';
          this.monthFormattedAis = dataAis ? this.formatMonth(dataAis+'-01') : '';

          const dataLaudo = response.data.tabela_resumo.data_base_laudo_blindado;
          this.monthLaudo = dataLaudo ? dataLaudo : '';
          this.monthFormattedLaudo = dataLaudo ? this.formatMonth(dataLaudo+'-01') : '';
        })
        .catch(() => this.$toast.error('Erro ao tentar pegar última data base', ''))
        .finally(() => this.iniciarPrimeiraTabTour());
      },

      postPredicao() {
        this.loading = true;
        let data = []

        let validacao = this.validation(this.rows);
        if(validacao)return;

        const tucagens = this.assembleTucagen(
          this.rows.filter(
            row =>
              row[0].trim() &&
              row[1].replaceAll(".", "").replaceAll(",", ".").trim() &&
              row[2].replaceAll(".", "").replaceAll(",", ".").trim() &&
              parseInt(row[2].replaceAll(".", "").replaceAll(",", ".")) > parseInt(row[1].replaceAll(".", "").replaceAll(",", "."))
          )
        );
        const dataBase = this.base === 'ais' ? this.monthAis+'-01' : this.base === 'laudo' ? this.monthLaudo+'-01' : null;

        data['titulo']           =  this.titulo
        data['base']             =  this.base
        data['precisao']         =  this.precisao;
        data['tucagens']         =  tucagens;
        data['data_base']        =  dataBase;
        data['variaveis']        =  this.variaveis.join().toLowerCase();
 
        if (tucagens.length == 0) {
          this.$toast.warning('Preencha a lista de tucagens e quantidades.', '', { position:'topRight' });
          this.loading = false;
          return;
        }

        //const idRelatorio = this.$route.params.id ? this.$route.params.id : null
        const user = this.$store.getters.getUser;
        PredicoesService.postPredicao(data,null,user.uid)
          .then((response) => {
            this.$toast.success('Predição salva com sucesso.', '',{position:'topRight'});
            this.$router.push({ name: 'Predições de Baixas Histórico' });
          })
          .catch(error => {
            console.error(error);
            this.$toast.error('Erro ao salvar predição.', '',{position:'topRight'});
          })
          .finally(() => this.loading = false);
      },

      validation(rows){
        var erro = 0;
        rows.forEach((row,index) => {
          const tucagem = row[0];
          const qtdMin = row[1].replaceAll(".", "").replaceAll(",", ".");
          const qtdMax = row[2].replaceAll(".", "").replaceAll(",", ".");
          
          const tucagemRegex = /^[0-9.]+$/;
          if (!tucagemRegex.test(tucagem)) {
              this.$toast.error('O campo Tucagem deve conter apenas números e ".".', '', { position: 'topRight' });
              const element = document.querySelector(`[data-y='${index}']`);
              element.classList.add("spreadsheet-error")
              erro++
          }

          if(parseInt(qtdMin) >= parseInt(qtdMax)){
            this.$toast.error('Qtd Min não pode ser maior ou igual a Qtd Max.', '',{position:'topRight'});
            const element = document.querySelector(`[data-y='${index}']`);
            element.classList.add("spreadsheet-error")
            erro++
          }

          if(qtdMin < 0 || qtdMax < 0){
            this.$toast.error('Qtd Min ou a Qtd Max não pode ser menor que 0.', '',{position:'topRight'});
            const element = document.querySelector(`[data-y='${index}']`);
            element.classList.add("spreadsheet-error")
            erro++
          }
        })

        if(erro > 0){
          this.loading = false;
          return true;
        }
        return false;
      },

      assembleTucagen(data){
        var ObjectTucagens = []
        data.forEach(function(tucagen, index) {        
          ObjectTucagens[index] = {
            "tucagen":tucagen[0],
            "qtd_min":parseInt(tucagen[1].replaceAll(".", "").replaceAll(",", ".")),
            "qtd_max":parseInt(tucagen[2].replaceAll(".", "").replaceAll(",", "."))
          }
        });
        return ObjectTucagens;
      },

      parseMonth(date) {
        if (!date) return null;

        const [month, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}`;
      },

      formatMonth(date) {
        if (date.length > 10) { date = date.substr(0, 10)};
        return dayjs(date).format('MM/YYYY');
      },
    },

    watch: {
      stepsProps() {
        for (let i = 1; i <= 3; i++) {
          (this.validTabs[i] && this.validTabs[i-1]) 
            ? this.availableSteps.push(i) 
            : this.availableSteps = this.availableSteps.filter(key => key != i);
        }
        if (this.validTabs[2] && this.validTabs[3] == undefined) this.availableSteps.push(3);
      },
      base() {
        if (this.base === 'ais') {
          this.variaveis = ['VOC'];
        }
        else if (this.base === 'laudo') {
          this.variaveis = ['VOC'];
        }
      }
    }
  }
</script>

<style lang="sass">
  .v-card.v-card.v-card--account
    border-color: currentColor
    border-width: 4px

  .v-icon
    color: inherit

  .v-card--account,
  .v-card--account:before
    border-radius: 50%
</style>